import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SizesGuideComponent } from './static/sizes-guide/sizes-guide.component';
import { CheckoutComponent } from './static/checkout/checkout.component';
import { CheckoutSuccessComponent } from './static/checkout/success/checkout-success.component';
import { PageNotFoundComponent } from './static/page-not-found/page-not-found.component';
import { OurBlogComponent } from './modules/marketplace/components/our-blog/our-blog.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/marketplace/marketplace.module').then(
        (m) => m.MarketplaceModule
      ),
  },
  {
    path: 'products',
    loadChildren: () =>
      import('./modules/products/products.module').then(
        (m) => m.ProductsModule
      ),
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./modules/legal/legal.module').then(
        (m) => m.LegalModule
      ),
  },
  {
    path: 'info',
    loadChildren: () =>
      import('./modules/info/info.module').then(
        (m) => m.InfoModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(
        (m) => m.AuthModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/profile/profile.module').then(
        (m) => m.ProfileModule
      ),
  },
  {
    path: 'about-us',
    loadComponent: () =>
      import('./modules/info/company-info/company-info.component').then(
        (m) => m.CompanyInfoComponent
      ),
    title: 'About Us - BROCOM Industry',
  },
  {
    path: 'blog',
    component: OurBlogComponent,
  },
  {
    path: 'about',
    redirectTo: 'about-us',
    pathMatch: 'full',
  },
  {
    path: 'sizes-guide',
    component: SizesGuideComponent,
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
  },
  {
    path: 'checkout/success',
    component: CheckoutSuccessComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'disabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0],
    onSameUrlNavigation: 'reload',
    enableTracing: false,
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
